import { ModelFactory } from '@shared/factories/model.factory';
import { BillingAddressType } from '@generated/graphql';
import { BillingAddress } from '@modules/address/models/billing-address.model';
import { OrderBillingAddress } from "@modules/order/models/order-billing-address.model";

export class BillingAddressFactory extends ModelFactory<BillingAddressType, BillingAddress> {
  create (state: BillingAddressType): BillingAddress {
    return new BillingAddress(state);
  }

  createFromOrderBillingAddress (
    address: OrderBillingAddress,
  ): BillingAddress {
    const state = {
      user: undefined,
      ...address,
    }

    return this.create(state)
  }
}

export const billingAddressFactory = new BillingAddressFactory();
